(() => {
  const dialog = document.getElementById('jootti-welcome');
  if (!dialog || dialog.dataset.joottiWelcomeInitialized) return;
  dialog.dataset.joottiWelcomeInitialized = 'true';

  const dismissedKey = 'jootti_welcome_dismissed_until_v1';
  // A submitted Shopify form may still await double opt-in confirmation.
  const submittedKey = 'jootti_welcome_subscribed_v1';
  const week = 7 * 24 * 60 * 60 * 1000;
  const qaMode = dialog.dataset.qaPreview === 'true'
    ? new URLSearchParams(location.search).get('jootti_welcome')
    : null;
  const success = Boolean(dialog.querySelector('[data-jootti-welcome-success]'));
  const error = Boolean(dialog.querySelector('[data-jootti-welcome-error]'));
  let lastFocus = null;

  const getSaved = (key) => {
    try { return localStorage.getItem(key); } catch { return null; }
  };
  const save = (key, value) => {
    try { localStorage.setItem(key, value); } catch {}
  };
  const excludedPath = () => {
    const path = location.pathname.toLowerCase();
    return /(^|\/)(cart|checkout|search)(\/|$)/.test(path) || path.includes('/apps/redo') ||
      path.includes('/pages/bfs-setup-builder') || path.includes('/pages/compare');
  };
  const shoppingInteraction = () => {
    if (location.hash.toLowerCase().startsWith('#jootti-compare')) return true;
    if (document.activeElement?.closest?.('[data-jootti-compare]')) return true;
    const compare = document.querySelector('[data-jootti-compare]');
    if (compare) {
      const rect = compare.getBoundingClientRect();
      if (rect.top < innerHeight * .85 && rect.bottom > innerHeight * .15) return true;
    }
    if (document.body.classList.contains('no-mobile-scroll')) return true;
    return Boolean(document.querySelector('.header__mobile-nav-toggle[aria-expanded="true"], .modal[aria-hidden="false"], dialog[open]:not(#jootti-welcome), [role="dialog"][aria-modal="true"]:not(#jootti-welcome)'));
  };
  const show = () => {
    if (dialog.open || (!success && !error && shoppingInteraction())) return;
    lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    dialog.showModal();
    const target = dialog.querySelector(success ? '#jootti-welcome-title' : '#jootti-welcome-email');
    target?.focus({ preventScroll: true });
  };

  if (success) {
    save(submittedKey, 'true');
    show();
  } else if (error) {
    show();
  } else if (!excludedPath() &&
    (qaMode === 'preview' || qaMode === 'timing' ||
      (getSaved(submittedKey) !== 'true' && Number(getSaved(dismissedKey) || 0) < Date.now()))) {
    window.setTimeout(show, qaMode === 'preview' ? 0 : 15000);
  }

  dialog.querySelectorAll('[data-jootti-welcome-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close('dismissed'));
  });
  dialog.addEventListener('close', () => {
    if (!success) save(dismissedKey, String(Date.now() + week));
    if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
  });

  const form = dialog.querySelector('form');
  const submit = dialog.querySelector('[data-jootti-welcome-submit]');
  form?.addEventListener('submit', () => {
    if (submit) submit.disabled = true;
  });
  window.addEventListener('pageshow', () => {
    if (submit) submit.disabled = false;
  });

})();
